import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { euroRoiDef, unitRoiDef } from './metricDefinitions';

const calculateEuroRoi = (reach: number, investment: number): number => {
  if (investment < 1) {
    return 0;
  }
  return (reach - investment) / investment;
};

const calculateUnitRoi = (reach: number, investment: number): number => {
  if (investment < 1) {
    return 0;
  }

  return reach / investment;
};

type CalculateRoiParams = {
  mediaIncrementalSales: number;
  investment: number;
  // The model's KPI unit (model_kpi_parameters.kpi_unit === 'euro') decides
  // the formula: euro KPIs net out the investment, unit KPIs are effect/spend
  isEuro: boolean;
};

export const calculateRoi = ({
  mediaIncrementalSales,
  investment,
  isEuro,
}: CalculateRoiParams): number => {
  if (isEuro) {
    return calculateEuroRoi(mediaIncrementalSales, investment);
  }

  return calculateUnitRoi(mediaIncrementalSales, investment);
};

export const useRoiDef = () => {
  const { isEuro } = useKpiUnit();
  const { metricLabel } = useKpiMetricLabels();

  return isEuro ? euroRoiDef(metricLabel) : unitRoiDef(metricLabel);
};
